export const PanelColors = {
    0: '#5D7D4F',
    1: '#4F7D5D',
    2: '#5D7D4F',
    3: '#4F667D',
    4: '#534F7D',
    5: '#6F4F7D',
    6: '#7D4F6F',
    7: '#98797C',
    8: '#7D664F',
    9: '#787D4F',
    10: '#6b3f3f',
    99: '#6b3f3f'
};
